const action = require('../action/action');

const copyText = Object.assign({}, action, {

    act: function () {
        if (typeof this.hm.app.components[this.target] !== typeof undefined) {
            let targetComponent = this.hm.app.components[this.target];

            let text = false;

            //the value as written in the page, when the target writes one (data-zit-raw-value: an input, a label). Not
            //the target's rawValue: readZAttributes() parses that one as JSON, so a long all-digit value would be copied
            //as a rounded number (12345678901234567890 → 12345678901234567000), and 12.50 as 12.5. A target that writes
            //none is copied by its own value
            let rawValueAttribute = targetComponent.element.dataset.zitRawValue;

            if (typeof rawValueAttribute !== typeof undefined) {
                text = rawValueAttribute;
            } else {
                text = targetComponent.getValue();
            }

            //copied as text, and the user told so (helper.copyToClipboard())
            this.hm.helper.copyToClipboard(text);
        }
    }
});

module.exports = copyText;